import { translate } from '@jsverse/transloco';

export function removeFromArray<T>(arr: T[], item: T) {
  const index = arr.findIndex((el) => item === el);

  return arr.splice(index, 1);
}

export function enumToSelectItemArray<T extends object>(model: T, prefix: string, translateObj: string) {
  return Object.values(model).map((item) => {
    return { label: translate(`${prefix}${translateObj}${item}`), value: item };
  });
}

export function trackBy(index: number, item: string): string {
  return `${index}-${item}`;
}

export function toStringValue(value: string | string[]): string {
  return Array.isArray(value) ? value.join(' ') : value;
}
